/** The maximum number of allowed parameters per HTTP request. */
export const USERDETAILS_MAX_PARAM_NUMBER = 50;
export const INSTANCE_SOFT_DELETE_LIFETIME_DAYS = 90;
